<template>
  <div>
    <el-table :data="list.value" border height="650" style="margin-top: 20px" row-key="id">
      <el-table-column width="180" prop="templateCode" label="模板代码">
        <template slot-scope="{ row }">
          {{ row.templateCode || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="templateName" label="提示名称">
      </el-table-column>
      <el-table-column prop="title" label="主标题">
      </el-table-column>
      <el-table-column prop="subTitle" label="副标题">
      </el-table-column>
      <el-table-column label="操作" width="140">
        <template slot-scope="{ row }">
          <el-button v-auth="'PROMPT_TEMPLATE_EDIT'" type="text" size="small" @click="edit(row)">编辑</el-button>
          <el-button v-auth="'PROMPT_TEMPLATE_DEL'" type="text" size="small" @click="del(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <ElementPagination style="margin-bottom: 20px" :current-page="searchParams.current" :page-size="searchParams.size"
      :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" />
    <EditDialog ref="editDialog" @reload="getList"></EditDialog>
  </div>
</template>

<script>
import { fullHitTemplateRemove, ullHitTemplatePage } from "@/api/apps/securityPolicy";
import ElementPagination from "@/components/ElementPagination";
import Message from "@/components/Message";
import EditDialog from "./edit.vue";
export default {
  name: "WebSaaSTable",
  inject: ["list", "searchParams", "getList"],

  props: {
    displayPage: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  components: {
    ElementPagination,
    EditDialog,
  },
  created() {
    this.getList();
  },
  methods: {
    /** 编辑的事件 */
    edit(row) {
      console.log("编辑的数据", row);
      this.$refs.editDialog.initData(row);
    },
    /** 删除的事件 */
    async del(id) {
      try {
        await this.$confirm("此操作将删除该模板, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });

        const { data } = await fullHitTemplateRemove({ id: id });
        if (data.code === 200) {
          Message.success("删除成功");
          this.getList();
        }
      } catch (error) {
        console.log(error);
      }
    },
    //^ ^--------------分页相关-------------^ ^
    /** loadList */
    async getList() {
      const { data } = await ullHitTemplatePage(this.searchParams);
      console.log("分页的响应", data);
      this.list.value = data.data.records;
      this.searchParams.total = data.data.total;
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.getList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.tableCard {
  margin-bottom: 4px;

  .text {
    background-color: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
    padding: 0 10px;
    line-height: 20px;
  }
}
</style>
